import { IconButton, useTheme } from '@material-ui/core';
import { useHistory } from 'react-router';
import { RootState } from 'src/store';
import React, { useState,useEffect } from 'react';
import useMediaQuery from '@material-ui/core/useMediaQuery/useMediaQuery';
import MenuIcon from '@material-ui/icons/Menu';
import enterIco from '../assets/icons/enter-ico.svg';
import faqIcon from '../assets/icons/faq-ico.svg';
import blogIcon from '../assets/icons/blog-ico.svg';
import eventIcon from '../assets/icons/event-ico.png';
import mailIcon from '../assets/icons/mail-ico.svg';
import { APP_ROUTES } from '../../../../../routing/AppRoutes';
import { useStyles } from '../styles';
import { v4 as uuidv4 } from 'uuid';
import { NavHeaderLink } from '../components/NavHeaderLink';
import { LoginMenu } from './LoginMenu';
import { useDispatch, useSelector } from 'react-redux';
import { openLoginModal } from 'src/store/layout/slice';
import CloseIcon from '@material-ui/icons/Close';

const HeaderItem: React.FC<any> = (props) => {
  const classes = useStyles();
  const { img, alt, title, onClick } = props;
  return (
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions
    <div className={classes.menu__link} onClick={onClick}>
      {img && <img src={img} alt={alt} className={classes.menuIco} />}
      <span>{title}</span>
    </div>
  );
};

export const UnAuthorizedMenu: React.FC<any> = (props) => {
  const { onLoginClick, onJournalistRegisterClick, onExpertRegisterClick } = props;
  const classes = useStyles();
  const { user } = useSelector((state: RootState) => state.auth);
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up('md'));

  const [isOpened, setOpened] = useState(false);

  const dispatch = useDispatch();
  const history = useHistory();
  
  const eventsClick = (event: React.MouseEvent<HTMLElement>) => {
	  history.push(`${APP_ROUTES.EVENTS_NEW}?tab=posts`);
	  window.location.reload(); 
	  /* if(user) {
		  history.push(`${APP_ROUTES.EVENTS_NEW}?tab=posts`);
		  window.location.reload(); 
	  }else {
		  dispatch(openLoginModal("Expert"));
	  } */
  }

  const blogElDom = (
    <NavHeaderLink to={APP_ROUTES.ALLPOSTS} title="Blog" img={blogIcon} alt="BLOG POST" />
  );

  const eventsnewElDom = (
    <div style={{color: 'black', cursor: 'pointer', display: 'flex', alignItems: 'center'}} className={classes.menu__link} onClick={eventsClick}>
		<img style={{marginRight: '15px'}} src={eventIcon} alt="Story ideas" className={classes.menuIco} />
		<span>Story ideas</span>
	</div>
  );

  const faqElDom = (
    <NavHeaderLink to={APP_ROUTES.FAQ} title="FAQ" img={faqIcon} alt="FAQ" />
  );

  const contactsElDom = (
    <NavHeaderLink
      to={APP_ROUTES.CONTACTS}
      title="Contact Us"
      img={mailIcon}
      alt="Mail"
    />
  );
  const loginElDom = (
    <LoginMenu />
  );
  const regAsAJournalistDom = (
    <HeaderItem
      title="Register as a journalist"
      onClick={onJournalistRegisterClick}
    />
  );
  const regAsAnExpertDom = (
    <HeaderItem
      title="Register as an Expert"
      onClick={onExpertRegisterClick}
    />
  );

  const loginAsAJournalistDom = (
    <HeaderItem
      title="Login as a Journalist"
      onClick={() => dispatch(openLoginModal("Journalist"))}
    />
  );

  const loginAsAnExpertDom = (
    <HeaderItem
      title="Login as an Expert"
      onClick={() => dispatch(openLoginModal("Expert"))}
    />
  );

  const [menuOpen, setMenuOpen] = useState([
    {
      val: "login",
      active: false,
      menuList:[loginAsAJournalistDom, loginAsAnExpertDom]
    },
    {
      val: "register",
      active: false,
      menuList:[regAsAJournalistDom, regAsAnExpertDom]
    },
    {
      val: "menu",
      active: false,
      menuList:[faqElDom, contactsElDom, blogElDom, eventsnewElDom]
    }
  ]);

  const openmenuActive = (obj:any) =>{
    const updateArr = menuOpen.filter((x:any)=> {
      if(x.val === obj){
        x.active = !x.active
      }else{
        x.active = false
      }
      return x
    })
    setMenuOpen(updateArr)
  }

  const closeMenu = () => {
    const updateMenu = menuOpen.filter((x:any)=> {x.active = false; return x});
    setMenuOpen(updateMenu)
  }
  
  useEffect(() => {
    const onScroll = (e:any) => {
      if(e.target.documentElement.scrollTop >= 100){
        closeMenu()
      }
    };
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const mobileList = (
    <>
      <div className={classes.iconWrap}>
        {menuOpen?.map((item:any)=>(
          <IconButton 
            className={classes.iconBtn}  
            onClick={() => openmenuActive(item.val)}>
            {item.val === "login" && 
              <svg className={item.active ? classes.activeIcon : ''} width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect width="25.6667" height="25.6667" rx="12.8333" fill="#ECF7FC" />
                <path d="M11 19.0209V17.6459H15.2778V8.02087H11V6.64587H15.2778C15.6139 6.64587 15.9017 6.78062 16.1413 7.05012C16.3808 7.31962 16.5004 7.64321 16.5 8.02087V17.6459C16.5 18.024 16.3802 18.3478 16.1407 18.6173C15.9011 18.8868 15.6135 19.0213 15.2778 19.0209H11ZM9.77778 16.2709L8.9375 15.274L10.4958 13.5209H5.5V12.1459H10.4958L8.9375 10.3927L9.77778 9.39587L12.8333 12.8334L9.77778 16.2709Z" fill="#79C5F1" />
              </svg>
            }
            {item.val === "register" && 
              <svg className={item.active ? classes.activeIcon : ''} width="27" height="26" viewBox="0 0 27 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="0.666626" width="25.6667" height="25.6667" rx="12.8333" fill="#ECF7FC" />
                <path d="M15.7499 14.3458C13.7474 14.3458 9.74988 15.3516 9.74988 17.3708V18.8833H21.7499V17.3708C21.7499 15.3516 17.7524 14.3458 15.7499 14.3458ZM8.99988 11.3208V9.05208H7.49988V11.3208H5.24988V12.8333H7.49988V15.1021H8.99988V12.8333H11.2499V11.3208M15.7499 12.8333C16.5455 12.8333 17.3086 12.5146 17.8712 11.9473C18.4338 11.38 18.7499 10.6106 18.7499 9.80833C18.7499 9.00605 18.4338 8.23662 17.8712 7.66933C17.3086 7.10203 16.5455 6.78333 15.7499 6.78333C14.9542 6.78333 14.1912 7.10203 13.6286 7.66933C13.0659 8.23662 12.7499 9.00605 12.7499 9.80833C12.7499 10.6106 13.0659 11.38 13.6286 11.9473C14.1912 12.5146 14.9542 12.8333 15.7499 12.8333Z" fill="#79C5F1" />
              </svg>
            }
            {item.val === "menu" && !item.active && <MenuIcon /> }
            {item.val === "menu" && item.active && <CloseIcon /> }
          </IconButton>
        ))}
      </div>
          
      {menuOpen?.map((item:any)=>(
        <ul className={
          `${classes.menu__list} ${classes.menu__mobileMenu} 
          ${item.active && classes.menu__mobileMenu_active}`
        }>
          {item.menuList.map((list:any)=>(
            <li>
              <div onClick={closeMenu}>
                {list}
              </div>
            </li>
          ))}
        </ul>
      ))}


    </>
  );

  const desktopList = (
    <ul className={`${classes.menu__list} ${classes.menu__desktopList}`}>
      {[
		blogElDom,
    eventsnewElDom,
        faqElDom,
        contactsElDom,
        loginElDom,
        regAsAJournalistDom,
        regAsAnExpertDom,
      ].map((el) => (
        <li key={uuidv4()}>{el}</li>
      ))}
    </ul>
  );

  return <>{isDesktop ? desktopList : mobileList}</>;
};
